import type { FormValues } from "@/widgets/classic-form/form";
import type { FormLevelFeatureType } from "@/entities/form-metadata";
import { type FeatureOfType } from "@/entities/form-metadata";

export const populateTimespanFeature = ({
    feature,
    dataModel,
    formValues,
    matchAllTermsExactly,
}: {
    feature: FeatureOfType<FormLevelFeatureType.Timespan>;
    dataModel: FormValues;
    formValues: FormValues;
    matchAllTermsExactly: boolean;
}): void => {
    const sourceTimespan = dataModel.timespan;
    if (!sourceTimespan) return;

    const matchModeValue = matchAllTermsExactly ? "mustMatch" : (sourceTimespan.matchMode ?? "rankOnly");

    const hasYearRange = sourceTimespan.yearEnd != null && sourceTimespan.yearStart != null;

    if (hasYearRange) {
        formValues.timespan = {
            yearStart: sourceTimespan.yearStart,
            yearEnd: sourceTimespan.yearEnd,
            matchMode: matchModeValue,
            isVisible: true,
        };
    } else {
        formValues.timespan = {
            yearStart: feature.attributes.sliderRange.min,
            yearEnd: feature.attributes.sliderRange.max,
            matchMode: matchModeValue,
            isVisible: true,
        };
    }
};
